export default [
    {
      path: '/admin/product-labels',
      name: 'product-label',
      meta: { requiresAuth: true },
      component: () => import('@/pages/product/label')
    }
  ]